function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 13,
  cy: 13,
  r: 13
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "PlusCircleDark",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "circle"
}, /*#__PURE__*/React.createElement("use", {
  fillOpacity: 0,
  fill: "#000000",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#767E9D",
  strokeWidth: 3,
  cx: 13,
  cy: 13,
  r: 11.5
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.75,11.75 L14.25,11.75 L14.25,9.25 C14.25,8.56 13.69,8 13,8 C12.31,8 11.75,8.56 11.75,9.25 L11.794375,11.75 L9.25,11.75 C8.56,11.75 8,12.31 8,13 C8,13.69 8.56,14.25 9.25,14.25 L11.794375,14.205625 L11.75,16.75 C11.75,17.44 12.31,18 13,18 C13.69,18 14.25,17.44 14.25,16.75 L14.25,14.205625 L16.75,14.25 C17.44,14.25 18,13.69 18,13 C18,12.31 17.44,11.75 16.75,11.75 Z",
  id: "plus",
  fill: "#848AA3"
})));

var SvgPlusCircleDark = function SvgPlusCircleDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlusCircleDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PlusCircleDark.94b7d7bb.svg";
export { ForwardRef as ReactComponent };